import { CheckOutlined, CopyOutlined } from "@ant-design/icons";
import type { IntlShape } from "@formatjs/intl";
import { Button, Flex } from "antd";
import type { SizeType } from "antd/es/config-provider/SizeContext";
import {
  formatStandbyEndClipboard,
  formatStandbyReportedClipboard,
  type StandbyClipboardContext,
} from "../utils/formatStandbyClipboard";
import { useCopySession } from "../utils/useCopySession";

type StandbyPeriodLike = {
  id?: string;
  started_at?: string | null;
  ended_at?: string | null;
  planned_end?: string | null;
  message?: string | null;
};

type StandbyCopyButtonsProps = {
  period: StandbyPeriodLike;
  context: StandbyClipboardContext;
  intl: IntlShape;
  size?: SizeType;
};

export const StandbyCopyButtons = ({
  period,
  context,
  intl,
  size = "small",
}: StandbyCopyButtonsProps) => {
  const { copiedId, copySession } = useCopySession();
  const startCopyId = `${period.id}:start`;
  const endCopyId = `${period.id}:end`;

  return (
    <Flex gap="small" wrap>
      <Button
        size={size}
        icon={copiedId === startCopyId ? <CheckOutlined /> : <CopyOutlined />}
        onClick={() =>
          copySession(
            startCopyId,
            formatStandbyReportedClipboard(context, {
              reason: period.message,
              startedAt: period.started_at,
              plannedEnd: period.planned_end,
            })
          )
        }
      >
        {intl.formatMessage({
          id:
            copiedId === startCopyId
              ? "ticket_report_copied"
              : "standby_clipboard_copy_start",
        })}
      </Button>
      {period.ended_at && (
        <Button
          size={size}
          icon={copiedId === endCopyId ? <CheckOutlined /> : <CopyOutlined />}
          onClick={() =>
            copySession(
              endCopyId,
              formatStandbyEndClipboard(context, { endedAt: period.ended_at })
            )
          }
        >
          {intl.formatMessage({
            id:
              copiedId === endCopyId
                ? "ticket_report_copied"
                : "standby_clipboard_copy_end",
          })}
        </Button>
      )}
    </Flex>
  );
};
